import axios from "axios";
import { clearAuthSession, redirectToLogin } from "../helpers/logout";
import { encryptStorageUtils } from "./encryptStorage";

let isHandlingUnauthorized = false;
const handleUnauthorized = () => {
  if (isHandlingUnauthorized) return;
  isHandlingUnauthorized = true;

  clearAuthSession();

  const currentPath = window.location.pathname;
  if (currentPath !== "/login") {
    redirectToLogin();
  } else {
    isHandlingUnauthorized = false;
  }
};

const createAxiosInstance = () => {
  const jwtToken = encryptStorageUtils.getAuthTokenFromStorage() || "";

  const api = axios.create({
    baseURL: window.env.BACKEND_API_URL,
    headers: {
      Authorization: `Bearer ${jwtToken as string}`,
    },
  });

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        handleUnauthorized();
      }
      return Promise.reject(error);
    }
  );

  return api;
};

export default createAxiosInstance;
